// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".affiliate_root__2SLO7 {\n  width: 100%;\n  background: #fff;\n  height: 100%; }\n", ""]);
// Exports
exports.locals = {
	"root": "affiliate_root__2SLO7"
};
module.exports = exports;
